<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <a-drawer
    @close="closeEdit"
    :visible="show"
    class="custom-class"
    title="编辑策略"
    placement="right"
    width="44%"
  >
    <div class="edit-item">
      <span>策略名称</span>
      <span>{{ editInfo.name }}</span>
    </div>

    <a-form :model="modelRef" @finish="onFinish" @finishFailed="onFinishFailed">
      <a-form-item class="edit-item" name="cycle">
        <span>备份周期</span>
        <a-select
          class="select"
          dropdownClassName="search-select-dropdown"
          placeholder="星期一"
          v-model:value="modelRef.cycle"
        >
          <a-select-option value="星期一">星期一</a-select-option>
          <a-select-option value="星期二">星期二</a-select-option>
          <a-select-option value="星期三">星期三</a-select-option>
          <a-select-option value="星期五">星期五</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item class="edit-item">
        <span>备份时间</span>
        <a-time-picker v-model:value="modelRef.time" value-format="HH:mm:ss" />
      </a-form-item>

      <a-form-item class="edit-item">
        <span>状态</span>
        <a-switch v-model:checked="modelRef.status" />
      </a-form-item>
    </a-form>
    <template #footer>
      <div class="btns" style="text-align: left">
        <a-button class="button-primary" @click="onFinish" style="margin-right: 8px">保存</a-button>
        <a-button class="m-l button-base" @click="closeEdit">取消</a-button>
      </div>
    </template>
  </a-drawer>
</template>
<script>
import { defineComponent, reactive, toRaw } from "vue";
import { Button, Form, Input, Select, TimePicker, Switch } from "ant-design-vue";
import Drawer from "@/components/tsl-drawer/index";
import { useStore } from "vuex";
const FormItem = Form.Item;
const useForm = Form.useForm;

export default defineComponent({
  emits: ["close", "onGetList"],
  name: "plan-edit",
  props: {
    editInfo: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ADrawer: Drawer,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [TimePicker.name]: TimePicker,
    [Button.name]: Button,
    [Switch.name]: Switch,
    [Select.name]: Select,
    ASelectOption: Select.Option
  },
  setup(props, context) {
    const store = useStore();

    const modelRef = reactive({
      cycle: props.editInfo.cycle,
      time: props.editInfo.startTime,
      status: props.editInfo.status === 0 ? false : true
    });

    const closeEdit = () => {
      resetFields();
      context.emit("close");
    };

    const { resetFields } = useForm(modelRef);
    const onFinish = () => {
      const values = toRaw(modelRef);
      values.id = props.editInfo.id;
      store.commit("backup/updateDeviceById", values);
      context.emit("onGetList", values);
      resetFields();
    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };

    return {
      closeEdit,
      modelRef,
      onFinish,
      onFinishFailed
    };
  }
});
</script>

<style lang="less" scoped>
:deep(.ant-select-selection-placeholder) {
  color: #4e5969;
}
.select {
  width: 104px;
  height: 32px;
  margin-right: 8px;
  font-weight: 400;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.edit-item {
  height: 32px;
  margin-bottom: 16px;
  color: #1d2129;
  font-size: 14px;
  line-height: 32px;
  text-align: left;
  span:nth-child(1) {
    display: inline-block;
    width: 56px;
    margin-right: 24px;
    color: #86909c;
  }
}
</style>
